import { api } from "./api";

export const statesList = async () => {
  return await api.get(`get/states`);
};

export const districtsList = async (addUrl=null) => {
  return await api.get(`get/district?${addUrl}`);
};

